const PHONE = '(323) 745-2205';
const PHONE_HREF = 'tel:+13237452205';
const EMAIL = 'lisa@lisamerkledesign.com';
const ADDRESS = '215 N La Peer Dr';
const CITY = 'Beverly Hills, CA 90211';
const DIRECTIONS_URL = 'https://www.google.com/maps?cid=189405287750833219';
const EMBED_SRC = 'https://maps.google.com/maps?q=215+N+La+Peer+Dr+Beverly+Hills+CA+90211&output=embed&z=16&hl=en';

export default function LocationMapSection() {
  return (
    <section className="bg-[#F5F0E8] py-24">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-start">

          {/* Left: contact info */}
          <div className="lg:col-span-2 flex flex-col gap-8">
            <div>
              <span className="text-[10px] tracking-[0.25em] uppercase text-stone font-sans">Studio Location</span>
              <h2 className="font-display text-4xl md:text-5xl font-light text-charcoal mt-3 leading-tight">
                Beverly Hills<br />
                <em className="not-italic text-stone-dark">Design Studio</em>
              </h2>
            </div>

            <ul className="flex flex-col gap-6">
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center border border-stone/30 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-stone-dark text-base" />
                </div>
                <div>
                  <p className="text-charcoal/40 text-[10px] tracking-widest uppercase font-sans mb-1">Address</p>
                  <p className="text-charcoal font-sans text-sm font-semibold">{ADDRESS}</p>
                  <p className="text-charcoal/60 font-sans text-xs mt-0.5">{CITY}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center border border-stone/30 flex-shrink-0">
                  <i className="ri-phone-line text-stone-dark text-base" />
                </div>
                <div>
                  <p className="text-charcoal/40 text-[10px] tracking-widest uppercase font-sans mb-1">Phone</p>
                  <a href={PHONE_HREF} className="text-charcoal font-sans text-sm font-semibold hover:text-stone-dark transition-colors cursor-pointer">{PHONE}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center border border-stone/30 flex-shrink-0">
                  <i className="ri-mail-line text-stone-dark text-base" />
                </div>
                <div>
                  <p className="text-charcoal/40 text-[10px] tracking-widest uppercase font-sans mb-1">Email</p>
                  <a href={`mailto:${EMAIL}`} className="text-charcoal font-sans text-sm font-semibold hover:text-stone-dark transition-colors cursor-pointer">{EMAIL}</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center border border-stone/30 flex-shrink-0">
                  <i className="ri-time-line text-stone-dark text-base" />
                </div>
                <div>
                  <p className="text-charcoal/40 text-[10px] tracking-widest uppercase font-sans mb-1">Hours</p>
                  <p className="text-charcoal font-sans text-sm font-semibold">Mon – Fri, 9am – 6pm</p>
                  <p className="text-charcoal/60 font-sans text-xs mt-0.5">By appointment</p>
                </div>
              </li>
            </ul>

            <a
              href={DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-charcoal text-cream text-[10px] tracking-[0.18em] uppercase font-semibold font-sans rounded-full hover:bg-charcoal/80 transition-all cursor-pointer whitespace-nowrap self-start"
            >
              <i className="ri-navigation-line" />
              Get Directions on Google Maps
            </a>
          </div>

          {/* Right: real interactive Google Map */}
          <div className="lg:col-span-3 flex flex-col overflow-hidden rounded-lg border border-stone/25">
            <div className="w-full" style={{ height: '420px' }}>
              <iframe
                title="Lisa Merkle Design — 215 N La Peer Dr, Beverly Hills CA"
                src={EMBED_SRC}
                width="100%"
                height="100%"
                style={{ border: 'none', display: 'block' }}
                loading="lazy"
                allowFullScreen={false}
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="bg-charcoal px-7 py-4 flex items-center justify-between gap-4">
              <p className="text-cream/80 font-sans text-xs tracking-wide">{ADDRESS}, {CITY}</p>
              <a
                href={DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2 px-5 py-2 border border-cream/25 text-cream text-[10px] tracking-[0.15em] uppercase font-sans hover:bg-cream hover:text-charcoal transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
              >
                <i className="ri-external-link-line" />
                Open in Maps
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
